<!--
  This is a temporary component to display the affected system items in a test page.
-->
<template>
  <ul v-if="items && items.length > 0">
    <li v-for="item in items" :key="item.displayName">
      {{ item.displayName }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'CIS-Resource-Advisory-AffectedSystem',
  props: {
    items: {
      type: Array
    }
  }
};
</script>
